import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

const ACCENT = "#000000";

function Dialog({ onResult }) {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setShown(true));
    const onKey = (e) => { if (e.key === "Escape") onResult("cancel"); };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [onResult]);

  return (
    <div
      onMouseDown={(e) => { if (e.target === e.currentTarget) onResult("cancel"); }}
      style={{
        position: "fixed", inset: 0, zIndex: 100000,
        background: "rgba(0,0,0,0.55)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 16,
        opacity: shown ? 1 : 0, transition: "opacity 0.18s ease",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          width: "100%", maxWidth: 440,
          background: "#fff", borderRadius: 18,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
          padding: 24,
          transform: shown ? "translateY(0) scale(1)" : "translateY(8px) scale(0.98)",
          transition: "transform 0.2s cubic-bezier(0.22,1,0.36,1)",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 800, color: "#1a1a1a", marginBottom: 12 }}>
          Книга сохранена
        </div>

        <div style={{ fontSize: 15, lineHeight: 1.5, color: "#333", marginBottom: 22 }}>
          Ваша фотокнига сохранена. Вы всегда можете вернуться к ней и продолжить работу
          в разделе <b>«Мои книги»</b>.
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={() => onResult("ok")}
            style={{
              padding: "10px 22px", borderRadius: 12, border: "none",
              background: ACCENT, color: "#fff", fontSize: 15, fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Хорошо
          </button>
        </div>
      </div>
    </div>
  );
}

export function confirmLeaveBookModal() {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    document.body.appendChild(host);
    const root = createRoot(host);
    let resolved = false;
    const finish = (result) => {
      if (resolved) return;
      resolved = true;
      root.unmount();
      host.remove();
      resolve(result);
    };
    root.render(<Dialog onResult={finish} />);
  });
}